module.exports = __webpack_public_path__ + "static/img/cont_makeup_02.0c9cf91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/images/cont_makeup_02.png
// module id = /FwC
// module chunks = 0